module.exports = dompurify;